<template>
  <main>
    <h4 class="font-weight-bolder">SOCIOS</h4>
    <!-- <label for="customerName">customerCreationValidation</label>
    <p-switch
      type="success"
      class="mx-auto"
      on-text="SI"
      off-text="NO"
      v-bind="customerCreationValidation"
    ></p-switch> -->
    <!-- <button @click="test">hola</button> -->
    <!-- CUSTOMER CREATION DISPLAY -->
    <transition
      name="fade"
      enter-active-class="animate__animated animate__fadeInDown"
      leave-active-class="animate__animated animate__fadeOutUp"
      class="animate__delay-2s"
    >
      <card v-if="show.customerCreator" id="customerCreator" class="">
        <div class="d-flex flex-row">
          <div class="col-md-9">
            <div class="d-flex d-md-none flex-column justify-content-center">
              <div
                class="rounded-circle mx-auto overflow-hidden d-flex"
                style="height: 150px; width: 150px"
                :class="!avatarSrc ? 'bg-dark' : ''"
              >
                <img
                  v-if="avatarSrc"
                  class=""
                  :src="avatarSrc"
                  alt="Imagen Original"
                />
                <i
                  v-else
                  class="fa fa-user text-light mx-auto my-auto"
                  aria-hidden="true"
                  style="font-size: 180px"
                ></i>
              </div>
              <button
                class="btn btn-info w-auto mx-auto rounded-pill mb-4"
                @click="avatarUploadModal = true"
              >
                Subir foto
              </button>
              <div class="d-flex justify-content-around">
                <div class="mb-2 d-flex flex-column col-6">
                  <label for="customerName">Sucursal de origen</label>
                  <el-select
                    v-model="newCustomer.selectedOriginBranch"
                    placeholder="Seleccionar..."
                    size="small"
                    :class="{
                      'select-danger': !newCustomer.selectedOriginBranch,
                    }"
                  >
                    <el-option
                      v-for="(item, index) in branches"
                      :key="index"
                      :label="item.nombreSucursal"
                      :value="JSON.stringify(item)"
                    ></el-option>
                  </el-select>
                  <small
                    v-if="!newCustomer.selectedOriginBranch"
                    class="text-danger text-nowrap"
                    >Campo obligatorio</small
                  >
                </div>
                <div class="mb-2 d-flex flex-column col-6">
                  <label for="customerName">Acceso a Sucursal</label>
                  <el-select
                    v-model="newCustomer.accesoSucursal.estadoAcceso"
                    placeholder="Seleccionar..."
                    size="small"
                    :class="{
                      'select-danger': !newCustomer.accesoSucursal.estadoAcceso,
                    }"
                  >
                    <el-option
                      v-for="(item, index) in catalog__socioEstadosAcceso"
                      :key="index"
                      :label="item.glosa"
                      :value="item.glosa"
                    ></el-option>
                  </el-select>
                  <small
                    v-if="!newCustomer.accesoSucursal.estadoAcceso"
                    class="text-danger text-nowrap"
                    >Campo obligatorio</small
                  >
                </div>
              </div>
              <!-- <div>
                <label for="">Comentarios || Detalles</label>
                <textarea
                  class="form-control"
                  v-model="newCustomer.informacionAdicional.detalleFicha"
                  id="exampleFormControlTextarea1"
                  rows="3"
                ></textarea>
              </div> -->
            </div>
            <p class="mt-2 border-bottom">Información de Socio</p>
            <div class="row">
              <div class="mb-2 col-12 col-md-5 d-flex flex-column">
                <label for="customerName">Nombre</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.nombreSocio"
                  :class="{
                    'is-invalid': !newCustomer.nombreSocio,
                  }"
                />
                <small v-if="!newCustomer.nombreSocio" class="text-danger"
                  >Campo obligatorio</small
                >
              </div>
              <el-tooltip
                :open-delay="200"
                placement="top"
                :disabled="newCustomer.esExtranjero"
              >
                <template #content>
                  Ingresa el RUT sin puntos<br />
                  Ej: "1111111-1"
                </template>
                <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                  <label for="customerName">RUT</label>
                  <input
                    type="text"
                    id="customerName"
                    class="form-control"
                    v-model.trim="newCustomer.rut"
                    :class="{
                      'is-invalid': !newCustomer.rut || !rutValidator,
                    }"
                  />
                  <small v-if="!newCustomer.rut" class="text-danger"
                    >Campo obligatorio</small
                  >
                  <small
                    v-if="!rutValidator && newCustomer.rut"
                    class="text-danger"
                    >Debes ingresar un rut valido</small
                  >
                </div>
              </el-tooltip>
              <div class="mb-2 col-6 col-md-2 d-flex flex-column">
                <label for="customerName">Sexo</label>
                <el-select
                  v-model="newCustomer.sexo"
                  placeholder="Seleccionar..."
                  size="small"
                >
                  <el-option label="HOMBRE" value="HOMBRE"></el-option>
                  <el-option label="MUJER" value="MUJER"></el-option>
                  <el-option label="NO ESPECIFICADO" value=""></el-option>
                </el-select>
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex text-center flex-column">
                <label for="customerName">¿Extranjero?</label>
                <p-switch
                  type="success"
                  class="mx-auto"
                  on-text="SI"
                  off-text="NO"
                  v-model="newCustomer.esExtranjero"
                ></p-switch>
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <label for="customerName">Nacimiento</label>
                </div>
                <el-date-picker
                  type="date"
                  class="w-100"
                  placeholder="01-01-1900"
                  format="dd-MM-yyyy"
                  size="small"
                  value-format="yyyy-MM-dd"
                  v-model="newCustomer.informacionAdicional.fechaNacimiento"
                >
                </el-date-picker>
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Perfil</label>
                <el-select
                  id="datePickerfechaUltimoPago"
                  placeholder="Selecciona uno"
                  size="small"
                  value-format="dd-MM-yyyy"
                  v-model="newCustomer.perfilCuenta"
                  :class="{ 'select-danger': !newCustomer.perfilCuenta }"
                >
                  <el-option
                    class="select-default"
                    v-for="(item, index) in catalog__socioPerfiles"
                    :key="index"
                    :label="item.glosa"
                    :value="item.glosa"
                  >
                  </el-option>
                </el-select>
                <small v-if="!newCustomer.perfilCuenta" class="text-danger"
                  >Campo obligatorio</small
                >
              </div>

              <!-- Omitir hasta habilitar cargas -->
              <!-- <div class="mb-2 col-md-3">
                <label for="">Titular Convenio</label>
                <input
                  type="text"
                  placeholder="Rut del titular..."
                  class="form-control"
                />
              </div> -->
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Estado</label>
                <el-select
                  id="datePickerfechaUltimoPago"
                  placeholder="Selecciona uno"
                  size="small"
                  value-format="dd-MM-yyyy"
                  v-model="newCustomer.estadoCuenta"
                  :class="{ 'select-danger': !newCustomer.estadoCuenta }"
                >
                  <el-option
                    class="select-default"
                    v-for="(item, index) in catalog__socioEstados"
                    :key="index"
                    :label="item.glosa"
                    :value="item.glosa"
                  >
                  </el-option>
                </el-select>
                <small v-if="!newCustomer.estadoCuenta" class="text-danger"
                  >Campo obligatorio</small
                >
              </div>
              <el-tooltip
                :open-delay="200"
                placement="top"
                :disabled="customerCreationValidation && rutValidator"
              >
                <template #content
                  >Notifica el vencimiento de <br />de las membresías por correo
                </template>
                <div class="mb-2 col col-md d-flex flex-column text-center">
                  <label for="" class="">Notificar Vencimientos</label>
                  <p-switch
                    type="success"
                    class="mx-auto mb-0"
                    on-text="SI"
                    off-text="NO"
                    v-model="
                      newCustomer.informacionAdicional.notificarVencimiento
                    "
                  ></p-switch>
                </div>
              </el-tooltip>
            </div>
            <p class="mt-2 border-bottom">Información de Contacto</p>
            <div class="row">
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">e-mail</label>
                <input
                  type="email"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.autenticacion.email"
                  :class="{
                    'is-invalid':
                      !newCustomer.autenticacion.email || !emailValidator,
                  }"
                />
                <small
                  v-if="!newCustomer.autenticacion.email"
                  class="text-danger"
                  >Campo obligatorio</small
                >
                <small
                  v-if="!emailValidator && newCustomer.autenticacion.email"
                  class="text-danger"
                  >Correo invalido</small
                >
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">e-mail secundario</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.emailSecundario"
                />
              </div>

              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Teléfono</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.telefonoFijo"
                />
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Celular</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.celular"
                />
              </div>
            </div>
            <p class="mt-2 border-bottom">Información Geografica</p>
            <div class="row">
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">País</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionGeografica.pais"
                />
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">Ciudad</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionGeografica.ciudad"
                />
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">Región</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionGeografica.region"
                />
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">Comuna</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionGeografica.comuna"
                />
              </div>
              <div class="mb-2 col col-md-4 d-flex flex-column">
                <label for="customerName">Dirección</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="newCustomer.informacionGeografica.direccion"
                />
              </div>
            </div>
            <p class="mt-2 border-bottom">RR.SS.</p>
            <div class="row">
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-facebook-square fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #4267b2"
                  ></i>
                  <label for="">Facebook</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="fb.com/..."
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.facebook"
                />
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-twitter-square fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #1da1f2"
                  ></i>
                  <label for="">Twitter</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="twitter.com/..."
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.twitter"
                />
              </div>

              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-instagram fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #f56040"
                  ></i>
                  <label for="">Instagram</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="instagram.com/..."
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.instagram"
                />
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-linkedin-square fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #0e76a8"
                  ></i>
                  <label for="">Linkedin</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="linkedin.com/..."
                  class="form-control"
                  v-model.trim="newCustomer.informacionContacto.linkedin"
                />
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <el-tooltip
                :open-delay="200"
                placement="top"
                :disabled="customerCreationValidation && rutValidator"
              >
                <template #content> Completa los campos en rojo!</template>
                <div class="p-0 mr-4">
                  <button
                    class="btn btn-success"
                    :disabled="!customerCreationValidation || !rutValidator"
                    @click="handleCustomerCreation"
                  >
                    CREAR
                  </button>
                </div>
              </el-tooltip>
              <button
                class="btn btn-danger"
                @click="handleCancelCustomerCreation"
              >
                CANCELAR
              </button>
            </div>
          </div>
          <div class="col d-none d-md-flex flex-column justify-content-center">
            <div
              class="rounded-circle mx-auto overflow-hidden d-flex"
              style="height: 150px; width: 150px"
              :class="!avatarSrc ? 'bg-dark' : ''"
            >
              <img
                v-if="avatarSrc"
                class=""
                :src="avatarSrc"
                alt="Imagen Original"
              />
              <i
                v-else
                class="fa fa-user text-light mx-auto my-auto"
                aria-hidden="true"
                style="font-size: 180px"
              ></i>
            </div>
            <button
              class="btn btn-info w-75 mx-auto rounded-pill mb-4"
              @click="avatarUploadModal = true"
            >
              Subir foto
            </button>
            <div class="mb-2" v-if="agreementMember">
              <label for="customerName">RUT Titular Convenio</label>
              <input
                type="text"
                id="agreementHolder"
                placeholder="ej: 123456789-0"
                class="form-control"
                v-model.trim="newCustomer.informacionAdicional.rutTitularConvenio"
              />
              <small
                v-if="
                  newCustomer.informacionAdicional.rutTitularConvenio &&
                  !validateNID_chi(
                    newCustomer.informacionAdicional.rutTitularConvenio
                  )
                "
                class="text-danger text-nowrap"
                >Debes ingresar un rut valido</small
              >
            </div>
            <div class="mb-2">
              <label for="customerName">Sucursal de origen</label>
              <el-select
                v-model="newCustomer.selectedOriginBranch"
                placeholder="Seleccionar..."
                size="small"
                :class="{
                  'select-danger': !newCustomer.selectedOriginBranch,
                }"
              >
                <el-option
                  v-for="(item, index) in branches"
                  :key="index"
                  :label="item.nombreSucursal"
                  :value="JSON.stringify(item)"
                ></el-option>
              </el-select>
              <small
                v-if="!newCustomer.selectedOriginBranch"
                class="text-danger text-nowrap"
                >Campo obligatorio</small
              >
            </div>
            <div class="mb-2">
              <label for="customerName">Acceso a Sucursal</label>
              <el-select
                v-model="newCustomer.accesoSucursal.estadoAcceso"
                placeholder="Seleccionar..."
                size="small"
                :class="{
                  'select-danger': !newCustomer.accesoSucursal.estadoAcceso,
                }"
              >
                <el-option
                  v-for="(item, index) in catalog__socioEstadosAcceso"
                  :key="index"
                  :label="item.glosa"
                  :value="item.glosa"
                ></el-option>
              </el-select>
              <small
                v-if="!newCustomer.accesoSucursal.estadoAcceso"
                class="text-danger text-nowrap"
                >Campo obligatorio</small
              >
            </div>

            <div>
              <label for="">Comentarios || Detalles</label>
              <textarea
                class="form-control"
                v-model="newCustomer.informacionAdicional.detalleFicha"
                id="exampleFormControlTextarea1"
                :rows="agreementMember ? 1 : 2"
              ></textarea>
            </div>
          </div>
        </div>
      </card>
    </transition>
    <!-- CUSTOMERS DETAIL DISPLAY -->
    <transition
      name="fade"
      enter-active-class="animate__animated animate__fadeInDown"
      leave-active-class="animate__animated animate__fadeOutUp"
      class="animate__delay-2s"
    >
      <card v-if="show.customerDetails" id="customerDetails" class="">
        <div class="d-flex flex-row">
          <div class="col-md-9">
            <div class="d-flex d-md-none flex-column justify-content-center">
              <template v-if="enableCustomerEdit">
                <el-tooltip :open-delay="200" placement="top">
                  <template #content>Eliminar Socio</template>
                  <button
                    @click="startCustomerDeleteModal"
                    class="btn btn-danger p-0 mx-auto mb-0 mt-auto round-button rounded-circle position-absolute"
                  >
                    <i
                      class="fa fa-trash fa-2x ml-0 pl-0"
                      aria-hidden="true"
                    ></i>
                  </button>
                </el-tooltip>
              </template>
              <div
                class="rounded-circle mx-auto overflow-hidden d-flex"
                style="height: 150px; width: 150px"
                :class="!avatarSrc ? 'bg-dark' : ''"
              >
                <img
                  v-if="avatarSrc"
                  class=""
                  :src="avatarSrc"
                  alt="Imagen Original"
                />
                <i
                  v-else
                  class="fa fa-user text-light mx-auto my-auto"
                  aria-hidden="true"
                  style="font-size: 180px"
                ></i>
              </div>
              <button
                class="btn btn-primary w-auto mx-auto rounded-pill mb-4"
                @click="avatarUploadModal = true"
                :disabled="!enableCustomerEdit"
              >
                Cambiar foto
              </button>
              <div class="d-flex justify-content-around">
                <div class="mb-2 d-flex flex-column col-6">
                  <label for="customerName">Sucursal de origen</label>
                  <el-select
                    v-model="showingCustomer.selectedOriginBranch"
                    placeholder="Seleccionar..."
                    size="small"
                    disabled
                    :class="{
                      'select-danger': !newCustomer.selectedOriginBranch,
                    }"
                  >
                    <el-option
                      v-for="(item, index) in branches"
                      :key="index"
                      :label="item.nombreSucursal"
                      :value="JSON.stringify(item)"
                    ></el-option>
                  </el-select>
                  <small
                    v-if="!showingCustomer.selectedOriginBranch"
                    class="text-danger text-nowrap"
                    >Campo obligatorio</small
                  >
                </div>
                <div class="mb-2 d-flex flex-column col-6">
                  <label for="customerName">Acceso a Sucursal</label>
                  <el-select
                    v-model="showingCustomer.accesoSucursal.estadoAcceso"
                    placeholder="Seleccionar..."
                    size="small"
                    :disabled="!enableCustomerEdit"
                    :class="{
                      'select-danger':
                        !showingCustomer.accesoSucursal.estadoAcceso,
                    }"
                  >
                    <el-option
                      v-for="(item, index) in catalog__socioEstadosAcceso"
                      :key="index"
                      :label="item.glosa"
                      :value="item.glosa"
                    ></el-option>
                  </el-select>
                  <small
                    v-if="!showingCustomer.accesoSucursal.estadoAcceso"
                    class="text-danger text-nowrap"
                    >Campo obligatorio</small
                  >
                </div>
              </div>
            </div>
            <p class="mt-2 border-bottom">Información de Socio</p>
            <div class="row">
              <div class="mb-2 col-12 col-md-5 d-flex flex-column">
                <label for="customerName">Nombre</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  v-model.trim="showingCustomer.nombreSocio"
                  :disabled="!enableCustomerEdit"
                  :class="{
                    'is-invalid': !showingCustomer.nombreSocio,
                  }"
                />
                <small v-if="!showingCustomer.nombreSocio" class="text-danger"
                  >Campo obligatorio</small
                >
              </div>
              <el-tooltip
                :open-delay="200"
                placement="top"
                :disabled="true"
              >
                <template #content>
                  Ingresa el RUT sin puntos<br />
                  Ej: "1111111-1"
                </template>
                <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                  <label for="customerName">RUT</label>
                  <input
                    type="text"
                    id="customerName"
                    class="form-control"
                    v-model.trim="showingCustomer.rut"
                    :disabled="true"
                    :class="{
                      'is-invalid': !showingCustomer.rut || !rutValidator,
                    }"
                  />
                  <small v-if="!showingCustomer.rut" class="text-danger"
                    >Campo obligatorio</small
                  >
                  <small v-if="!rutValidator" class="text-danger"
                    >Debes ingresar un rut valido</small
                  >
                </div>
              </el-tooltip>
              <div class="mb-2 col-6 col-md-2 d-flex flex-column">
                <label for="customerName">Sexo</label>
                <el-select
                  v-model="showingCustomer.sexo"
                  placeholder="Seleccionar..."
                  size="small"
                  :disabled="!enableCustomerEdit"
                >
                  <el-option label="HOMBRE" value="HOMBRE"></el-option>
                  <el-option label="MUJER" value="MUJER"></el-option>
                  <el-option label="NO ESPECIFICADO" value=""></el-option>
                </el-select>
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex text-center flex-column">
                <label for="customerName">¿Extranjero?</label>
                <p-switch
                  type="success"
                  class="mx-auto"
                  id="esExtranjero"
                  on-text="SI"
                  off-text="NO"
                  :disabled="!enableCustomerEdit"
                  v-model="showingCustomer.esExtranjero"
                ></p-switch>
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <label for="customerName">Nacimiento</label>
                </div>
                <el-date-picker
                  type="date"
                  class="w-100"
                  placeholder="01-01-1900"
                  format="dd-MM-yyyy"
                  size="small"
                  :disabled="!enableCustomerEdit"
                  value-format="yyyy-MM-dd"
                  v-model="showingCustomer.informacionAdicional.fechaNacimiento"
                >
                </el-date-picker>
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Perfil</label>
                <el-select
                  id="datePickerfechaUltimoPago"
                  placeholder="Selecciona uno"
                  size="small"
                  :disabled="!enableCustomerEdit"
                  value-format="dd-MM-yyyy"
                  v-model="showingCustomer.perfilCuenta"
                  :class="{ 'select-danger': !showingCustomer.perfilCuenta }"
                >
                  <el-option
                    class="select-default"
                    v-for="(item, index) in catalog__socioPerfiles"
                    :key="index"
                    :label="item.glosa"
                    :value="item.glosa"
                  >
                  </el-option>
                </el-select>
                <small v-if="!showingCustomer.perfilCuenta" class="text-danger"
                  >Campo obligatorio</small
                >
              </div>

              <!-- Omitir hasta habilitar cargas -->
              <!-- <div class="mb-2 col-md-3">
              <label for="">Titular Convenio</label>
              <input
                type="text"
                placeholder="Rut del titular..."
                class=" form-control"
              />
            </div> -->
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Estado</label>
                <el-select
                  id="datePickerfechaUltimoPago"
                  placeholder="Selecciona uno"
                  size="small"
                  :disabled="!enableCustomerEdit"
                  value-format="dd-MM-yyyy"
                  v-model="showingCustomer.estadoCuenta"
                  :class="{ 'select-danger': !showingCustomer.estadoCuenta }"
                >
                  <el-option
                    class="select-default"
                    v-for="(item, index) in catalog__socioEstados"
                    :key="index"
                    :label="item.glosa"
                    :value="item.glosa"
                  >
                  </el-option>
                </el-select>
                <small v-if="!showingCustomer.estadoCuenta" class="text-danger"
                  >Campo obligatorio</small
                >
              </div>

              <div class="mb-2 col col-md d-flex flex-column text-center">
                <label for="" class="">Notificar Vencimientos</label>
                <p-switch
                  type="success"
                  id="notificarVencimiento"
                  class="mx-auto mb-0"
                  on-text="SI"
                  off-text="NO"
                  :disabled="!enableCustomerEdit"
                  v-model="
                    showingCustomer.informacionAdicional.notificarVencimiento
                  "
                ></p-switch>
              </div>
            </div>
            <p class="mt-2 border-bottom">Información de Contacto</p>
            <div class="row">
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">e-mail</label>
                <input
                  type="email"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.autenticacion.email"
                  :class="{
                    'is-invalid': !showingCustomer.autenticacion.email,
                  }"
                />
                <small
                  v-if="!showingCustomer.autenticacion.email"
                  class="text-danger"
                  >Campo obligatorio</small
                >
                <small
                  v-if="!emailValidator && showingCustomer.autenticacion.email"
                  class="text-danger"
                  >Correo invalido</small
                >
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">e-mail secundario</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.emailSecundario"
                />
              </div>

              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Teléfono</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.telefonoFijo"
                />
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <label for="customerName">Celular</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.celular"
                />
              </div>
            </div>
            <p class="mt-2 border-bottom">Información Geografica</p>
            <div class="row">
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">País</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionGeografica.pais"
                />
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">Ciudad</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionGeografica.ciudad"
                />
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">Región</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionGeografica.region"
                />
              </div>
              <div class="mb-2 col-4 col-md-2 d-flex flex-column">
                <label for="customerName">Comuna</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionGeografica.comuna"
                />
              </div>
              <div class="mb-2 col col-md-4 d-flex flex-column">
                <label for="customerName">Dirección</label>
                <input
                  type="text"
                  id="customerName"
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionGeografica.direccion"
                />
              </div>
            </div>
            <p class="mt-2 border-bottom">RR.SS.</p>
            <div class="row">
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-facebook-square fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #4267b2"
                  ></i>
                  <label for="">Facebook</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="fb.com/..."
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.facebook"
                />
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-twitter-square fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #1da1f2"
                  ></i>
                  <label for="">Twitter</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="twitter.com/..."
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.twitter"
                />
              </div>

              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-instagram fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #f56040"
                  ></i>
                  <label for="">Instagram</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="instagram.com/..."
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.instagram"
                />
              </div>
              <div class="mb-2 col-6 col-md-3 d-flex flex-column">
                <div>
                  <i
                    class="fa fa-linkedin-square fa-2x mr-1"
                    aria-hidden="true"
                    style="color: #0e76a8"
                  ></i>
                  <label for="">Linkedin</label>
                </div>
                <input
                  type="text"
                  id="customerName"
                  placeholder="linkedin.com/..."
                  class="form-control"
                  :disabled="!enableCustomerEdit"
                  v-model.trim="showingCustomer.informacionContacto.linkedin"
                />
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button
                class="btn btn-info mr-4"
                v-if="!enableCustomerEdit"
                @click="handleEnableCustomerEdit"
              >
                editar
              </button>
              <el-tooltip
                :open-delay="200"
                placement="top"
                :disabled="
                  customerCreationValidation &&
                  rutValidator &&
                  customerUpdateChangeCheck
                "
                v-else
              >
                <template #content>
                  {{
                    customerUpdateChangeCheck
                      ? `Completa todos los campos en rojo!`
                      : `No hay cambios que guardar!`
                  }}</template
                >
                <div class="p-0 mr-4">
                  <button
                    class="btn btn-success"
                    :disabled="
                      !customerCreationValidation ||
                      !rutValidator ||
                      !customerUpdateChangeCheck
                    "
                    @click="handleCustomerUpdate"
                  >
                    guardar
                  </button>
                </div>
              </el-tooltip>
              <button
                class="btn btn-danger"
                @click="handleCancelCustomerDetails"
              >
                {{ customerUpdateChangeCheck ? "CANCELAR" : "CERRAR" }}
              </button>
            </div>
          </div>
          <div
            class="col d-none d-md-flex flex-column justify-content-center py-2"
          >
            <div
              class="rounded-circle mx-auto overflow-hidden d-flex"
              style="height: 150px; width: 150px"
              :class="!avatarSrc ? 'bg-dark' : ''"
            >
              <img
                v-if="avatarSrc"
                class=""
                :src="avatarSrc"
                alt="Imagen Original"
              />
              <i
                v-else
                class="fa fa-user text-light mx-auto my-auto"
                aria-hidden="true"
                style="font-size: 180px"
              ></i>
            </div>
            <button
              class="btn btn-primary w-auto mx-auto rounded-pill mb-4"
              @click="avatarUploadModal = true"
              :disabled="!enableCustomerEdit"
            >
              Cambiar foto
            </button>
            <div class="mb-2" v-if="agreementMember">
              <label for="customerName">RUT Titular Convenio</label>
              <input
                type="text"
                id="agreementHolder"
                placeholder="123456789-0"
                class="form-control"
                :disabled="!enableCustomerEdit"
                v-model.trim="
                  showingCustomer.informacionAdicional.rutTitularConvenio
                "
              />
              <small
                v-if="
                  showingCustomer.informacionAdicional.rutTitularConvenio &&
                  !validateNID_chi(
                    showingCustomer.informacionAdicional.rutTitularConvenio
                  )
                "
                class="text-danger text-nowrap"
                >Debes ingresar un rut valido</small
              >
            </div>
            <div class="mb-2">
              <label for="customerName">Sucursal de origen</label>
              <el-select
                v-model="showingCustomer.selectedOriginBranch"
                placeholder="Seleccionar..."
                size="small"
                disabled
                :class="{
                  'select-danger': !showingCustomer.selectedOriginBranch,
                }"
              >
                <el-option
                  v-for="(item, index) in branches"
                  :key="index"
                  :label="item.nombreSucursal"
                  :value="JSON.stringify(item)"
                ></el-option>
              </el-select>
              <small
                v-if="!showingCustomer.selectedOriginBranch"
                class="text-danger text-nowrap"
                >Campo obligatorio</small
              >
            </div>
            <div class="mb-2">
              <label for="customerName">Acceso a Sucursal</label>
              <el-select
                v-model="showingCustomer.accesoSucursal.estadoAcceso"
                placeholder="Seleccionar..."
                size="small"
                :disabled="!enableCustomerEdit"
                :class="{
                  'select-danger': !showingCustomer.accesoSucursal.estadoAcceso,
                }"
              >
                <el-option
                  v-for="(item, index) in catalog__socioEstadosAcceso"
                  :key="index"
                  :label="item.glosa"
                  :value="item.glosa"
                ></el-option>
              </el-select>
              <small
                v-if="!showingCustomer.accesoSucursal.estadoAcceso"
                class="text-danger text-nowrap"
                >Campo obligatorio</small
              >
            </div>

            <div>
              <label for="">Comentarios || Detalles</label>
              <textarea
                class="form-control"
                v-model="showingCustomer.informacionAdicional.detalleFicha"
                id="exampleFormControlTextarea1"
                :disabled="!enableCustomerEdit"
                :rows="agreementMember ? 1 : 3"
              ></textarea>
            </div>
            <div
              class="w-100 d-flex flex-row justify-content-center"
              v-if="enableCustomerEdit"
            >
              <el-tooltip :open-delay="200" placement="top">
                <template #content>{{
                  show.asignMembership ? "Asignar Membresía" : "Ver Membresía"
                }}</template>
                <button
                  class="btn p-0 mb-0 mt-2 mr-2 round-button rounded-circle"
                  :class="show.asignMembership ? 'btn-primary' : 'btn-success'"
                  @click="goToMemberships(show.asignMembership)"
                >
                  <i
                    class="fa fa-2x ml-0 pl-0"
                    :class="show.asignMembership ? 'fa-plus' : 'fa-search '"
                    aria-hidden="true"
                  ></i>
                </button>
              </el-tooltip>
              <el-tooltip :open-delay="200" placement="top">
                <template #content>Eliminar Socio</template>
                <button
                  @click="startCustomerDeleteModal"
                  class="btn btn-danger p-0 mb-0 mt-2 round-button rounded-circle"
                >
                  <i class="fa fa-trash fa-2x ml-0 pl-0" aria-hidden="true"></i>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </card>
    </transition>
    <!-- CUSTOMERS LIST-TABLE -->
    <span class=""
      >Total:
      <badge class="" slot="title-label" type="success">{{
        pagination.total
      }}</badge></span
    >
    <div class="card p-4 mt-1">
      <div class="d-flex flex-column flex-md-row mb-2 mb-md-0">
        <div class="col-md-2 my-auto col-md-1 d-flex">
          <el-tooltip :open-delay="200" placement="top">
            <template #content> Crear Socio</template>
            <button
              type="button"
              class="btn btn-success p-0 round-button rounded-circle"
              @click="initiateCustomerCreator"
              :disabled="show.customerCreator"
            >
              <i class="fa fa-plus fa-3x" aria-hidden="true"></i>
            </button>
          </el-tooltip>
          <i
            class="fa fa-refresh ml-4 my-auto text-success pointer"
            aria-hidden="true"
            @click="refreshTable()"
          ></i>
          <div class="col-8 ml-auto mr-0 col d-md-none pr-0">
            <div class="d-flex mb-1">
              <label for="" class="my-auto">NOMBRE</label>
              <p-switch
                type="success"
                id="notificarVencimiento"
                class="mx-auto mb-0"
                size="small"
                v-model="searchByCustomerNID"
              ></p-switch>
              <label for="" class="my-auto">RUT</label>
            </div>
            <!-- <label for="nidSearch" class="">RUT</label> -->
            <div class="d-flex flex-row">
              <fg-input
                id="nidSearch"
                class="input-sm"
                :placeholder="searchByCustomerNID ? 'RUT...' : 'Nombre...'"
                @keyup.enter="searchCustomer(0)"
                v-model.trim="customerSearchParameter"
              >
              </fg-input>
              <i
                role="button"
                class="fa fa-search col-2 text-muted mt-1 fa-2x"
                @click="searchCustomer(0)"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row col-md justify-content-end px-0">
          <!-- <button type="button" class="btn btn-success rounded-pill">
            Fecha <br />Creación
          </button> -->
          <div class="col-md-3 d-flex flex-column">
            <label for="subfamilys-dropdown">Perfiles</label>
            <el-select
              class="select-default"
              v-model="tableFilters.profile"
              placeholder="Todas"
              size="small"
            >
              <el-option
                class="select-default"
                label="Todos"
                value=""
              ></el-option>
              <el-option
                class="select-default"
                v-for="(item, index) in catalog__socioPerfiles"
                :key="index"
                :label="item.glosa"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-3 d-flex flex-column">
            <label for="subfamilys-dropdown">Sucursales</label>
            <el-select
              class="select-default"
              size="small"
              v-model="tableFilters.branch"
              placeholder="Todas"
            >
              <el-option
                class="select-default"
                label="Todas"
                value=""
              ></el-option>
              <el-option
                class="select-default"
                v-for="(item, index) in branches"
                :key="index"
                :label="item.nombreSucursal"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="d-none d-md-block col-md-3 pr-0">
            <div class="d-flex mb-1">
              <label for="" class="my-auto">NOMBRE</label>
              <p-switch
                type="success"
                id="notificarVencimiento"
                class="mx-auto mb-0"
                v-model="searchByCustomerNID"
              ></p-switch>
              <label for="" class="my-auto">RUT</label>
            </div>
            <!-- <label for="nidSearch" class="">RUT</label> -->
            <fg-input
              id="nidSearch"
              class="input-sm"
              :placeholder="searchByCustomerNID ? 'RUT...' : 'Nombre...'"
              @keyup.enter="searchCustomer(0)"
              v-model.trim="customerSearchParameter"
              addon-right-icon="nc-icon nc-zoom-split"
            >
            </fg-input>
          </div>
        </div>
      </div>
      <table class="table table-striped table-hover rounded d-none d-md-table">
        <thead class="bg-warning rounded-top">
          <tr class="text-light">
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Sucursal</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="customers">
            <tr
              v-for="(customer, index) in customers"
              :key="index"
              @click="fetchCustomerDetails(customer.rut)"
              style="cursor: pointer"
            >
              <td role="button">{{ customer.rut }}</td>
              <td class="text-nowrap">{{ customer.nombreSocio }}</td>
              <td class="text-nowrap">{{ customer.nombreSucursal }}</td>
            </tr>
          </template>
          <!-- Table Loading Spinners -->
          <template v-if="!customers">
            <tr>
              <div
                class="spinner-border spinner-border-sm mx-4 my-4"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
              <td>...</td>
            </tr>
          </template>
        </tbody>
      </table>
      <table class="table d-md-none table-striped table-hover rounded">
        <thead class="bg-warning rounded-top">
          <tr class="text-light">
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="customers">
            <tr
              v-for="customer in customers"
              :key="customer.rut"
              @click="fetchCustomerDetails(customer.rut)"
              style="cursor: pointer"
            >
              <td role="button">{{ customer.rut }}</td>
              <td class="text-nowrap mobile-table-text" style="">
                {{ customer.nombreSocio }}
              </td>
            </tr>
          </template>
          <!-- Table Loading Spinners -->
          <template v-if="!customers">
            <tr>
              <div
                class="spinner-border spinner-border-sm mx-4 my-4"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr>
              <div class="spinner-border spinner-border-sm ml-4" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <td>
                <div
                  class="spinner-border spinner-border-sm ml-4"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="col-sm-6 container-fluid d-flex mt-4">
        <!-- <span class="position-absolute d-none d-md-flex float-right"
          >Total:
          <badge class="" slot="title-label" type="success">{{
            pagination.total
          }}</badge></span
        > -->
        <p-pagination
          class="pull-right mx-auto"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        >
          <!-- @input="onPageChange" -->
        </p-pagination>
      </div>
      <!-- <span class="d-md-none mx-auto"
        >Total:
        <badge class="" slot="title-label" type="success">{{
          pagination.total
        }}</badge></span
      > -->
    </div>
    <!-- MODAL UPLOAD/TAKE AVATAR PICTURE -->
    <modal :show.sync="avatarUploadModal" type="notice" class="">
      <div class="d-flex my-4" v-if="!pictureIsTaken">
        <div class="col-6 text-center">
          <i
            class="fa fa-cloud-upload fa-5x text-dark"
            aria-hidden="true"
            style="text-shadow: 1px 3px 5px #00000050"
          ></i>
          <input
            type="file"
            @change="handleAvatarFileUpload"
            ref="avatarInput"
            accept="image/*"
            class="d-none"
          />
          <button class="btn btn-info" @click="clickAvatarFileInput">
            Sube un archivo
          </button>
        </div>
        <div class="col-6 text-center border-left">
          <i
            class="fa fa-camera fa-5x text-dark"
            aria-hidden="true"
            style="text-shadow: 1px 3px 5px #00000050"
          ></i>
          <button class="btn btn-info" @click="setupCamera">
            Toma una foto
          </button>
        </div>
      </div>
      <template>
        <div :class="pictureIsTaken ? 'd-flex flex-column' : 'd-none'">
          <video
            ref="cameraPreview"
            autoplay
            playsinline
            style="width: 100%"
            class="border border-dark rounded"
            :class="webcamIsReady ? '' : 'd-none'"
          ></video>
          <div v-if="!webcamIsReady" class="text-center p-4">
            <div
              class="spinner-border text-secondary my-4"
              style="width: 3rem; height: 3rem"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <button
            @click="capturePhoto"
            class="btn btn-danger p-0 round-button rounded-circle mx-auto mt-4"
          >
            <i class="fa fa-camera fa-2x" aria-hidden="true"></i>
          </button>
          <canvas ref="canvas" id="canvas" class="d-none"></canvas>
          <!-- Se usa para capturar la foto -->
          <img ref="photo" id="photo" style="width: 100%" />
          <!-- Opcional: para mostrar la foto capturada -->
        </div>
      </template>
    </modal>
    <modal :show.sync="customerDeleteModal">
      <div class="d-flex flex-column">
        <h5>Para confirmar escribe "{{ showingCustomer.rut }}"</h5>
        <small class="text-danger">Esta acción no se puede revertir!</small>
        <small class="text-danger"
          >Eliminaras al socio, sus posibles membresias y huellas!</small
        >
        <div class="p-4 d-flex flex-column">
          <input
            type="text"
            id="customerName"
            placeholder="RUT DEL SOCIO...."
            class="form-control text-uppercase my-2"
            v-model="customerDeleteValidationString"
          />
          <button
            class="btn btn-danger mx-auto"
            :disabled="customerDeleteValidation"
            @click="
              handleCustomerDelete(
                showingCustomer.rut,
                showingCustomer.sucursal,
                showingCustomer.selectedBranch
              )
            "
          >
            ELIMINAR
          </button>
        </div>
      </div>
    </modal>
  </main>
</template>

<script>
import PPagination from "src/components/UIComponents/Pagination.vue";
import { Badge, Modal } from "src/components/UIComponents";
import { Tooltip, DatePicker } from "element-ui";
import PSwitch from "src/components/UIComponents/Switch.vue";
import { regex } from "vee-validate/dist/rules";
import _ from "lodash";
export default {
  components: {
    PPagination,
    Badge,
    Modal,
    PSwitch,
    [Tooltip.name]: Tooltip,
    [DatePicker.name]: DatePicker,
  },
  watch: {
    // showingCustomer: function (newValue) {
    //   console.log("cambios en this.showingCustomer");
    //   console.log(newValue);
    // },
    textt: function (n) {
      console.log(n);
    },
    // "newCustomer.avatar.imagenPerfil": function (newValue) {
    //   console.log("**************************************");
    //   console.log("**************************************");
    //   console.log("**************************************");
    //   console.log("**************************************");
    //   console.log("cambio en el avatar");
    //   console.log("nuevo valor: ", newValue);
    //   console.log("**************************************");
    //   console.log("**************************************");
    //   console.log("**************************************");
    //   console.log("**************************************");
    // },
    avatarUploadModal: function (newValue) {
      if (!newValue) {
        const video = this.$refs.cameraPreview;
        if (video.srcObject) {
          video.srcObject.getTracks().forEach((track) => track.stop());
        }
        this.pictureIsTaken = false;
        // Opcional: resetear el srcObject del video a null
        video.srcObject = null;
      }
    },
    "pagination.currentPage": function (newValue) {
      if (this.customerSearchParameter) {
        this.searchCustomer(newValue - 1);
      } else {
        this.fetchCustomersPage(newValue - 1);
      }
    },
    "tableFilters.branch": function (newValue) {
      // console.log(newValue);
      this.pagination.currentPage = 1;
      this.fetchCustomersPage(0);
    },
    "tableFilters.profile": function (newValue) {
      // console.log(newValue);
      this.pagination.currentPage = 1;
      this.fetchCustomersPage(0);
    },
  },
  computed: {
    agreementMember() {
      return (
        this.newCustomer.perfilCuenta === "CARGA" ||
        this.showingCustomer.perfilCuenta === "CARGA"
      );
    },
    customerCreationValidation() {
      const key = this.show.customerCreator ? "newCustomer" : "showingCustomer";
      if (
        this[key].nombreSocio &&
        this[key].rut &&
        this[key].perfilCuenta &&
        this[key].estadoCuenta &&
        this[key].autenticacion.email &&
        this[key].accesoSucursal.estadoAcceso &&
        this[key].selectedOriginBranch
      ) {
        return true;
      } else {
        return false;
      }
    },
    rutValidator() {
      const key = this.show.customerCreator ? "newCustomer" : "showingCustomer";
      if (this[`${key}`].esExtranjero) {
        // console.log("return true;");
        return true;
      } else {
        const nid = this[`${key}`].rut.trim();
        const regex = /^\d{7,8}-[\dkK]$/;
        const regexK = /^\d{7,8}-[kK]$/;
        if (!regex.test(nid) && !regexK.test(nid)) {
          // console.log("!regex.test(nid)");
          return false;
        }
        const parts = nid.split("-");
        const cuerpo = parts[0];
        const dv = parts[1].toUpperCase();
        let suma = 0;
        let multiplo = 2;
        for (let i = cuerpo.length - 1; i >= 0; i--) {
          suma += multiplo * cuerpo.charAt(i);
          multiplo = multiplo === 7 ? 2 : multiplo + 1;
        }

        let dvEsperado = 11 - (suma % 11);
        if (dvEsperado === 11) {
          dvEsperado = "0";
        } else if (dvEsperado === 10) {
          dvEsperado = "K";
        } else {
          dvEsperado = dvEsperado.toString();
        }
        // console.log("return dv === dvEsperado;");
        return dv === dvEsperado;
      }
    },
    customerDeleteValidation() {
      return (
        this.showingCustomer.rut !=
        this.customerDeleteValidationString.toUpperCase()
      );
      // return (this.showingCustomer.rut === this.customerDeleteValidationString)
    },
    emailValidator() {
      const key = this.show.customerCreator ? "newCustomer" : "showingCustomer";
      const regex = /^[a-zA-Z0-9._&-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,3}$/;
      return regex.test(this[key].autenticacion.email);
    },
    customerUpdateChangeCheck() {
      let updatedFields = {};
      Object.keys(this.showingCustomer).forEach((key) => {
        if (
          !_.isEqual(this.showingCustomer[key], this.showingCustomerOG[key])
        ) {
          updatedFields[key] = this.showingCustomer[key];
        }
      });
      if (Object.keys(updatedFields).length > 0 && this.enableCustomerEdit) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      ttrue: true,
      searchByCustomerNID: true,
      webcamIsReady: false,
      show: {
        customerCreator: false,
        customerDetails: false,
        asignMembership: false,
      },
      avatarUploadModal: false,
      customerDeleteModal: false,
      customerDeleteValidationString: "",
      avatarSrc: null,
      pictureIsTaken: false,
      newCustomer: {
        selectedOriginBranch: "",
        nombreSocio: "",
        esExtranjero: false,
        rut: "",
        sexo: "",
        perfilCuenta: "",
        estadoCuenta: "",
        autenticacion: {
          email: "",
          password: "123456",
        },
        informacionGeografica: {
          pais: "",
          ciudad: "",
          region: "",
          comuna: "",
          direccion: "",
        },
        informacionContacto: {
          emailSecundario: "",
          telefonoFijo: "",
          celular: "",
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: "",
        },
        informacionAdicional: {
          notificarVencimiento: true,
          fechaNacimiento: "",
          contrato: "",
          detalleFicha: "",
          rutTitularConvenio: "",
        },
        accesoSucursal: {
          estadoAcceso: "",
        },
        avatar: {
          imagenMiniatura: "",
          imagenPerfil: "",
        },
      },
      avatarSrc: "",
      showingCustomerOG: {},
      showingCustomer: {
        selectedOriginBranch: "",
        nombreSocio: "",
        esExtranjero: false,
        rut: "",
        sexo: "",
        perfilCuenta: "",
        estadoCuenta: "",
        autenticacion: {
          email: "",
          password: "",
        },
        informacionGeografica: {
          pais: "",
          ciudad: "",
          region: "",
          comuna: "",
          direccion: "",
        },
        informacionContacto: {
          emailSecundario: "",
          telefonoFijo: "",
          celular: "",
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: "",
        },
        informacionAdicional: {
          notificarVencimiento: true,
          fechaNacimiento: "",
          contrato: "",
          detalleFicha: "",
          rutTitularConvenio: "",
        },
        accesoSucursal: {
          estadoAcceso: "",
        },
        avatar: {
          imagenMiniatura: "",
          imagenPerfil: "",
        },
      },
      enableCustomerEdit: false,
      selectedOriginBranch: "",
      textt: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
      tableFilters: {
        branch: "",
        dateFrom: false,
        dateUntil: false,
        memberships: false,
        profile: "",
      },
      customers: false,
      customerSearchParameter: "",
      branches: [],
      searchCount: 0,
      catalog__socioEstados: [],
      catalog__socioEstadosAcceso: [],
      catalog__socioPerfiles: [],
    };
  },
  methods: {
    test(){
      console.log(this.newCustomer)
    },
    async refreshTable() {
      this.$swal.fire({
        text: "Un segundo por favor...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.customerSearchParameter = "";
      this.tableFilters = {
        branch: "",
        dateFrom: false,
        dateUntil: false,
        memberships: false,
        profile: "",
      };
      try {
        await this.fetchCustomersPage(0);
        this.$swal.close();
      } catch (ex) {
        this.$swal
          .fire({
            title: "Error! :(",
            text: "Ha ocurrido un error al actualizar, refrescando la ventana...",
            icon: "error",
            showConfirmButton: true,
          })
          .then(() => {
            window.location.reload();
          });
      }
    },
    validateNID_chi(nid) {
      const rut = nid.trim();
      const regex = /^\d{7,8}-[\dkK]$/;
      const regexK = /^\d{7,8}-[kK]$/;
      if (!regex.test(rut) && !regexK.test(rut)) {
        // console.log("!regex.test(rut)");
        return false;
      }
      const parts = rut.split("-");
      const cuerpo = parts[0];
      const dv = parts[1].toUpperCase();
      let suma = 0;
      let multiplo = 2;
      for (let i = cuerpo.length - 1; i >= 0; i--) {
        suma += multiplo * cuerpo.charAt(i);
        multiplo = multiplo === 7 ? 2 : multiplo + 1;
      }

      let dvEsperado = 11 - (suma % 11);
      if (dvEsperado === 11) {
        dvEsperado = "0";
      } else if (dvEsperado === 10) {
        dvEsperado = "K";
      } else {
        dvEsperado = dvEsperado.toString();
      }
      // console.log("return dv === dvEsperado;");
      return dv === dvEsperado;
    },
    goToMemberships() {
      this.$swal.fire({
        title: "Cargando...",
        text: "Espere un momento",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.$store.commit(
        "setCosturmerNIDcustomersAndMemberhipsFilter",
        this.showingCustomer.rut
      );
      this.$router.push("/customers&memberships/memberships");
    },
    startCustomerDeleteModal() {
      this.customerDeleteModal = true;
    },
    async handleCustomerDelete(nid, branchId, branchName) {
      this.$swal.fire({
        title: "Eliminado...",
        text: "Esto puede tomar unos segundos",
        allowOutsideClick: false,
        confirmButtonColor: "#6bd098",
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        await this.$MasterControlAPI
          .post(
            "",
            {
              Header: {
                Operacion: "/v3/user/socios/eliminar",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                rut: nid,
                idSucursal: branchId,
                nombreSucursal: branchName,
              },
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.$swal.close();
            this.customerDeleteValidationString = "";
            this.customerDeleteModal = false;
            // console.log(res.data.Response);
            if (
              res.data.Response.Resultado.CodigoHTTP === 200 ||
              res.data.Response.Resultado.CodigoHTTP === 201
            ) {
              // console.log(this.customers);
              _.remove(this.customers, (customer) => customer.rut === nid);
              // console.log(this.customers);
              this.showingCustomer = {
                selectedOriginBranch: "",
                nombreSocio: "",
                esExtranjero: false,
                rut: "",
                sexo: "",
                perfilCuenta: "",
                estadoCuenta: "",
                autenticacion: {
                  email: "",
                  password: "",
                },
                informacionGeografica: {
                  pais: "",
                  ciudad: "",
                  region: "",
                  comuna: "",
                  direccion: "",
                },
                informacionContacto: {
                  emailSecundario: "",
                  telefonoFijo: "",
                  celular: "",
                  facebook: "",
                  twitter: "",
                  instagram: "",
                  linkedin: "",
                },
                informacionAdicional: {
                  notificarVencimiento: true,
                  fechaNacimiento: "",
                  contrato: "",
                  detalleFicha: "",
                  rutTitularConvenio: "",
                },
                accesoSucursal: {
                  estadoAcceso: "",
                },
                avatar: {
                  imagenMiniatura: "",
                  imagenPerfil: "",
                },
              };
              this.showingCustomerOG = {};
              this.avatarSrc = "";
              this.show.customerDetails = false;
              this.$swal.fire({
                title: "Exito!",
                text: "Socio eliminado correctamente!",
                icon: "success",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            } else {
              this.$swal.fire({
                title: "Error! :(",
                text: res.data.Response.Resultado.MensajeServicio,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
          });
      } catch (error) {
        // console.log(error);
        this.$swal.fire({
          title: "Error! :(",
          text: error.data.Response.Resultado.MensajeServicio || error.message,
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    handleEnableCustomerEdit() {
      this.showingCustomerOG = _.cloneDeep(this.showingCustomer);
      this.enableCustomerEdit = true;
    },
    async handleCustomerUpdate() {
      // console.log(this.showingCustomer);
      this.$swal.fire({
        title: "Cargando...",
        text: "Espera un momento",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const { selectedOriginBranch, sucursal, rut, ...updatedCustomer } =
        this.showingCustomer;
      if (
        typeof updatedCustomer.informacionAdicional.notificarVencimiento ===
        "undefined"
      ) {
        updatedCustomer.informacionAdicional.notificarVencimiento = true;
      }

      try {
        await this.$MasterControlAPI
          .post(
            "",
            {
              Header: {
                Operacion: "/v3/user/socios/actualizar",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                rut: rut,
                idSucursal: sucursal,
                nombreSucursal: selectedOriginBranch,
              },
              Body: { ...updatedCustomer },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.$swal.close();
            if (
              res.data.Response.Resultado.CodigoHTTP === 200 ||
              res.data.Response.Resultado.CodigoHTTP === 201
            ) {
              this.enableCustomerEdit = false;
              this.$swal.fire({
                title: "Exito!",
                text: "Modificación realizada con éxito",
                icon: "success",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            } else {
              this.$swal.fire({
                title: "Error! :(",
                text: res.data.Response.Resultado.MensajeServicio,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
          });
      } catch (ex) {
        this.$swal.fire({
          title: "Error! :(",
          text: ex.data.Response.Resultado.MensajeServicio || ex.message,
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    handleCancelCustomerDetails() {
      if (this.customerUpdateChangeCheck && this.enableCustomerEdit) {
        // console.log("if");
        this.enableCustomerEdit = false;
        this.showingCustomer = _.cloneDeep(this.showingCustomerOG);
        this.showingCustomerOG = {};
      } else {
        // console.log("else");
        this.showingCustomer = {
          selectedOriginBranch: "",
          nombreSocio: "",
          esExtranjero: false,
          rut: "",
          sexo: "",
          perfilCuenta: "",
          estadoCuenta: "",
          autenticacion: {
            email: "",
            password: "",
          },
          informacionGeografica: {
            pais: "",
            ciudad: "",
            region: "",
            comuna: "",
            direccion: "",
          },
          informacionContacto: {
            emailSecundario: "",
            telefonoFijo: "",
            celular: "",
            facebook: "",
            twitter: "",
            instagram: "",
            linkedin: "",
          },
          informacionAdicional: {
            notificarVencimiento: true,
            fechaNacimiento: "",
            contrato: "",
            detalleFicha: "",
            rutTitularConvenio: "",
          },
          accesoSucursal: {
            estadoAcceso: "",
          },
          avatar: {
            imagenMiniatura: "",
            imagenPerfil: "",
          },
        };
        this.showingCustomerOG = {};
        this.enableCustomerEdit = false;
        this.show.customerDetails = false;
      }
    },
    async fetchCustomerDetails(nid) {
      this.$swal.fire({
        title: "cargando...",
        text: "Por favor espere",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.enableCustomerEdit = false;
      this.show.customerDetails = false;
      this.show.customerCreator = false;
      this.customerSearchParameter = "";
      this.showingCustomerOG = {};
      this.showingCustomer = {
        selectedOriginBranch: "",
        nombreSocio: "",
        esExtranjero: false,
        rut: "",
        sexo: "",
        perfilCuenta: "",
        estadoCuenta: "",
        autenticacion: {
          email: "",
          password: "",
        },
        informacionGeografica: {
          pais: "",
          ciudad: "",
          region: "",
          comuna: "",
          direccion: "",
        },
        informacionContacto: {
          emailSecundario: "",
          telefonoFijo: "",
          celular: "",
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: "",
        },
        informacionAdicional: {
          notificarVencimiento: true,
          fechaNacimiento: "",
          contrato: "",
          detalleFicha: "",
          rutTitularConvenio: "",
        },
        accesoSucursal: {
          estadoAcceso: "",
        },
        avatar: {
          imagenMiniatura: "",
          imagenPerfil: "",
        },
      };
      this.newCustomer = {
        selectedOriginBranch: "",
        nombreSocio: "",
        esExtranjero: false,
        rut: "",
        sexo: "",
        perfilCuenta: "",
        estadoCuenta: "",
        autenticacion: {
          email: "",
          password: "123456",
        },
        informacionGeografica: {
          pais: "",
          ciudad: "",
          region: "",
          comuna: "",
          direccion: "",
        },
        informacionContacto: {
          emailSecundario: "",
          telefonoFijo: "",
          celular: "",
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: "",
        },
        informacionAdicional: {
          notificarVencimiento: true,
          fechaNacimiento: "",
          contrato: "",
          detalleFicha: "",
          rutTitularConvenio: "",
        },
        accesoSucursal: {
          estadoAcceso: "",
        },
        avatar: {
          imagenMiniatura: "",
          imagenPerfil: "",
        },
      };
      // console.log(nid);
      try {
        await this.$MasterControlAPI
          .post(
            "",
            {
              Header: {
                Operacion: "/v3/user/socios/consultar",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                rut: nid,
                nombreSocio: "",
              },
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            if (
              res.data.Response.Resultado.CodigoHTTP === 200 ||
              res.data.Response.Resultado.CodigoHTTP === 201
            ) {
              const foundCustomer = res.data.Response.DataOut.registros[0];
              // console.log(foundCustomer);
              this.showingCustomer = {
                selectedOriginBranch: foundCustomer.nombreSucursal,
                nombreSocio: foundCustomer.nombreSocio,
                esExtranjero: foundCustomer.esExtranjero,
                rut: foundCustomer.rut.trim(),
                sexo: foundCustomer.sexo,
                perfilCuenta: foundCustomer.perfilCuenta.glosa,
                estadoCuenta: foundCustomer.estadoCuenta.glosa,
                sucursal: foundCustomer.sucursal,
                autenticacion: {
                  email: foundCustomer.autenticacion.email,
                },
                informacionGeografica: {
                  ...foundCustomer.informacionGeografica,
                },
                informacionContacto: {
                  ...foundCustomer.informacionContacto,
                },
                informacionAdicional: {
                  ...foundCustomer.informacionAdicional,
                },
                accesoSucursal: {
                  estadoAcceso:
                    foundCustomer.accesoSucursales[0].estadoAcceso.glosa,
                },
                avatar: {
                  imagenMiniatura:
                    foundCustomer.avatar.imagenes.imagenMiniatura,
                  imagenPerfil: foundCustomer.avatar.imagenes.imagenPerfil,
                },
              };
              this.avatarSrc = `data:image/jpg;base64, ${foundCustomer.avatar.imagenes.imagenPerfil}`;
              if (!foundCustomer.planes.principal) {
                // console.log("sin plan");
                this.show.asignMembership = true;
              } else {
                // console.log("con plan");
                this.show.asignMembership = false;
              }
              this.show.customerDetails = true;
            } else {
              this.$swal.fire({
                title: "Error! :(",
                text:
                  res.data.Response.Resultado ||
                  `Codigo de error: ${res.data.Response.Resultado.CodigoHTTP}`,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
            // console.log(res.data.Response);
            this.$swal.close();
          });
      } catch (error) {
        this.$swal.fire({
          title: "Error! :(",
          text: error.message || error,
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async handleCustomerCreation() {
      this.$swal.fire({
        title: "Cargando...",
        text: "Un momento por favor",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let { selectedOriginBranch, ...createdCustomer } = this.newCustomer;
      if (
        !createdCustomer.avatar.imagenPerfil ||
        !createdCustomer.avatar.imagenMiniatura
      ) {
        createdCustomer.avatar.imagenPerfil =
          this.$store.getters.getAvatarPlaceHolder;
        createdCustomer.avatar.imagenMiniatura =
          this.$store.getters.getAvatarPlaceHolder;
      }
      const originBranch = JSON.parse(selectedOriginBranch);
      const Body = {
        Header: { Operacion: "/v3/user/socios/ingresar/nuevo" },
        Auth: { Token: sessionStorage.getItem("jCxbraoQeD") },
        Parameters: {
          idSucursal: originBranch._id,
          nombreSucursal: originBranch.nombreSucursal,
        },
        Body: { ...createdCustomer },
      };
      await this.$MasterControlAPI
        .post("", Body, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(async (res) => {
          this.$swal.close();
          if (
            res.data.Response.Resultado.CodigoHTTP === 200 ||
            res.data.Response.Resultado.CodigoHTTP === 201
          ) {
            this.$swal
              .fire({
                title: "Exito!",
                text: "Socio creado de forma exitosa",
                icon: "success",
                showConfirmButton: true,
              })
              .then(async () => {
                this.newCustomer = {
                  selectedOriginBranch: "",
                  nombreSocio: "",
                  esExtranjero: false,
                  rut: "",
                  sexo: "",
                  perfilCuenta: "",
                  estadoCuenta: "",
                  autenticacion: {
                    email: "",
                    password: "123456",
                  },
                  informacionGeografica: {
                    pais: "",
                    ciudad: "",
                    region: "",
                    comuna: "",
                    direccion: "",
                  },
                  informacionContacto: {
                    emailSecundario: "",
                    telefonoFijo: "",
                    celular: "",
                    facebook: "",
                    twitter: "",
                    instagram: "",
                    linkedin: "",
                  },
                  informacionAdicional: {
                    notificarVencimiento: true,
                    fechaNacimiento: "",
                    contrato: "",
                    detalleFicha: "",
                    rutTitularConvenio: "",
                  },
                  accesoSucursal: {
                    estadoAcceso: "",
                  },
                  avatar: {
                    imagenMiniatura: "",
                    imagenPerfil: "",
                  },
                };
                await this.fetchCustomerDetails(createdCustomer.rut);
              });
          } else {
            this.$swal.fire({
              title: `Error ${res.data.Response.Resultado.CodigoHTTP} ):`,
              text: res.data.Response.Resultado.MensajeServicio,
              icon: "error",
              confirmButtonColor: "#6bd098",
            });
          }
        })
        .catch((ex) => {
          this.$swal.close();
          let message =
            ex.response.data.Response.Resultado.MensajeServicio || ex;
          this.$swal.fire({
            title: "Ha ocurrido un error :(",
            text: message,
            icon: "error",
          });
        });
    },
    initiateCustomerCreator() {
      this.avatarSrc = "";
      this.show.customerDetails = false;
      this.show.customerCreator = true;
    },
    async setupCamera() {
      this.pictureIsTaken = true;
      this.webcamIsReady = false;
      if (this.$refs.cameraPreview) {
        try {
          await navigator.mediaDevices
            .getUserMedia({
              video: true,
            })
            .then((res) => {
              // console.log("video is loaded");
              this.webcamIsReady = true;
              this.$refs.cameraPreview.srcObject = res;
            });
        } catch (error) {
          console.error(
            "Error al acceder a la cámara del dispositivo:",
            error.message || error
          );
        }
      } else {
        console.error("El elemento de video no está disponible.");
      }
    },
    async capturePhoto() {
      // console.log('this.show.customerCreator')
      const key = this.show.customerCreator ? "newCustomer" : "showingCustomer";
      // Preparar el canvas para la foto original
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");
      const video = this.$refs.cameraPreview;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

      // Obtener la foto original como Base64
      const originalBase64 = canvas.toDataURL("image/jpeg");

      this.avatarSrc = originalBase64;
      // Opcional: Mostrar la foto capturada
      // if (this.show.customerCreator) {
      //   this.avatarSrc = originalBase64;
      // } else {
      //   this.avatarSrc = originalBase64;
      // }

      // Calcular las nuevas dimensiones para la miniatura
      const maxSize = 100; // Máximo tamaño para la miniatura
      let width = video.videoWidth;
      let height = video.videoHeight;
      if (width > height) {
        if (width > maxSize) {
          height = height * (maxSize / width);
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width = width * (maxSize / height);
          height = maxSize;
        }
      }

      // Ajustar el tamaño del canvas para la miniatura
      canvas.width = width;
      canvas.height = height;
      context.drawImage(video, 0, 0, width, height);

      // Obtener la miniatura como Base64
      const thumbnailBase64 = canvas.toDataURL("image/jpeg");

      // Guardar o procesar las imágenes Base64 como sea necesario
      this[key].avatar.imagenPerfil = this.trimBase64String(originalBase64);
      this[key].avatar.imagenMiniatura = this.trimBase64String(thumbnailBase64);

      // console.log("Original Base64:", originalBase64);
      // console.log("Thumbnail Base64:", thumbnailBase64);
      // Detener el uso de la cámara
      if (video.srcObject) {
        video.srcObject.getTracks().forEach((track) => track.stop());
      }

      // Opcional: resetear el srcObject del video a null
      video.srcObject = null;

      // Cerrar el modal después de la captura (si es necesario)
      this.avatarUploadModal = false;
    },
    trimBase64String(base64String) {
      const base64DataStart =
        base64String.indexOf("base64,") + "base64,".length;
      if (base64DataStart === -1 + "base64,".length) {
        console.error("La cadena no contiene datos Base64 válidos.");
        return "";
      }
      return base64String.substring(base64DataStart);
    },
    clickAvatarFileInput() {
      this.$refs.avatarInput.click();
    },
    handleAvatarFileUpload(event) {
      const file = event.target.files[0];
      if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const key = this.show.customerCreator
              ? "newCustomer"
              : "showingCustomer";
            // Imagen original en Base64
            const originalBase64 = e.target.result;
            this.avatarSrc = originalBase64;
            // if (this.show.customerCreator) {
            //   this.avatarSrc = originalBase64;
            // } else {
            //   this.avatarSrc = originalBase64;
            // }
            // Crear miniatura
            const canvas = document.createElement("canvas");
            const maxSize = 100; // Máximo tamaño para la miniatura
            let width = img.width;
            let height = img.height;

            const canvasOriginal = document.createElement("canvas");
            canvasOriginal.width = img.width;
            canvasOriginal.height = img.height;
            const ctxOriginal = canvasOriginal.getContext("2d");
            ctxOriginal.drawImage(img, 0, 0, img.width, img.height);

            const originalJPEGBase64 = canvasOriginal.toDataURL("image/jpeg");

            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            const thumbnailBase64 = canvas.toDataURL("image/jpeg");

            // Aquí puedes manejar las cadenas Base64 como necesites
            this[key].avatar.imagenPerfil =
              this.trimBase64String(originalJPEGBase64);
            this[key].avatar.imagenMiniatura =
              this.trimBase64String(thumbnailBase64);
            this.avatarUploadModal = false;
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.$swal.fire({
          title: `Error`,
          text: `Sólo puedes subir imagenes`,
          icon: `error`,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    handleAvatarFileUploaded(fullImage, thumbnail) {},
    async fetchCustomersPage(page) {
      var filters = { ...this.tableFilters };
      this.customerSearchParameter = "";
      if (this.searchByCustomerNID && this.customerSearchParameter) {
        filters.nid = this.customerSearchParameter;
      } else if (!this.searchByCustomerNID && this.customerSearchParameter) {
        filters.name = this.customerSearchParameter;
      }
      this.customers = false;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                filter: { ...filters },
                page: page ? page : 0,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/customers",
              },
            }
          )
          .then((res) => {
            if (!res.data.error) {
              this.customers = res.data.result;
              if (this.pagination.total != res.data.count) {
                this.pagination.total = res.data.count;
              }
            } else {
              this.$swal.fire({
                title: "Error! :(",
                text: res.data.error,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
          });
      } catch (ex) {
        this.$swal.fire({
          title: "Error! :(",
          text: ex.message || ex,
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async searchCustomer(page) {
      if (this.customerSearchParameter === "vaya un mapache") {
        console.log("⠀⠀⠀⠀⣀⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀   ");
        console.log("⠀⠀⠀⡌⡀⠉⠓⢤⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀  ⣀⣠⠄⡄⠀");
        console.log("⠀⠀⠀⣇⢧⣶⡠⣬⣿⣶⣤⣤⣠⣴⣦⣤⣄⣀⠀⣀⣠⠞⢛⣡⣴⣾⣾⠀");
        console.log("⠀⠀⠀⠹⡜⣿⣿⣯⠻⠻⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⣶⣩⣽⣿⡿⡽⠀");
        console.log("⠀⠀⠀⠀⢺⠄⡻⠀⠐⢻⣿⣿⣿⣿⠻⢻⠿⢻⣿⢿⣿⣿⣿⣿⡿⡕⠁⠀");
        console.log("⠀⠀⠀⠀⢨⡆⠁⠀⠀⠀⠀⣿⡟⠃⠀⠈⠀⠀⠈⠻⢻⣿⣿⠏⢠⠃⠀⠀");
        console.log("⠀⠀⠀⠀⢨⠃⠀⣀⣰⡄⢰⡿⠁⢠⣆⣀⠀⠀⠀⠀⠈⠻⢧⠀⢇⠀⠀⠀");
        console.log("⠀⠀⠀⠀⠞⠀⣼⣿⣾⡗⢸⠇⣰⣿⣿⣿⣿⣷⣤⠤⠀⢀⢈⠀⢸⡂⠀⠀");
        console.log("⠀⠈⠐⠤⠆⢼⣿⣿⠋⠀⠀⠀⠀⠻⣿⣿⣿⣿⣿⣿⣿⣚⣟⠀⠀⢳⡄⠀");
        console.log("⠀⠤⠤⢴⠧⣐⡺⢅⣤⣶⣶⡀⠀⠀⣻⣿⣿⠟⣻⣿⣿⡿⠷⢶⡀⠀⢻⠂");
        console.log("⠀⢈⡩⠿⢷⠒⠒⣺⣿⣿⣿⣧⣶⠠⠈⢨⣻⣿⡿⣿⣿⣿⡤⡄⢩⣬⡿⠆");
        console.log("⠈⠀⠀⠀⢚⡃⢀⣿⣿⣛⣿⣛⣻⣯⣽⣿⣿⣿⣿⣮⣿⣿⣿⣶⣦⣽⡍⠀");
        console.log("⠀⠀⠀⠀⢸⣅⢹⣿⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣾⠻⠃⠀");
        console.log("⠀⠀⠀⠀⠈⠋⠘⠻⠋⢿⣿⣿⣿⣿⣿⣿⣿⣿⠿⠟⠛⠛⠁⠁⠀⠀⠀⠀");
        console.log("⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈          EGhCh");
      } else {
        this.customers = false;
        this.newCustomer = {
          selectedOriginBranch: "",
          nombreSocio: "",
          esExtranjero: false,
          rut: "",
          sexo: "",
          perfilCuenta: "",
          estadoCuenta: "",
          autenticacion: {
            email: "",
            password: "123456",
          },
          informacionGeografica: {
            pais: "",
            ciudad: "",
            region: "",
            comuna: "",
            direccion: "",
          },
          informacionContacto: {
            emailSecundario: "",
            telefonoFijo: "",
            celular: "",
            facebook: "",
            twitter: "",
            instagram: "",
            linkedin: "",
          },
          informacionAdicional: {
            notificarVencimiento: true,
            fechaNacimiento: "",
            contrato: "",
            detalleFicha: "",
            rutTitularConvenio: "",
          },
          accesoSucursal: {
            estadoAcceso: "",
          },
          avatar: {
            imagenMiniatura: "",
            imagenPerfil: "",
          },
        };
        if (this.showingCustomer.rut) {
          this.showingCustomer = {
            selectedOriginBranch: "",
            nombreSocio: "",
            esExtranjero: false,
            rut: "",
            sexo: "",
            perfilCuenta: "",
            estadoCuenta: "",
            autenticacion: {
              email: "",
              password: "",
            },
            informacionGeografica: {
              pais: "",
              ciudad: "",
              region: "",
              comuna: "",
              direccion: "",
            },
            informacionContacto: {
              emailSecundario: "",
              telefonoFijo: "",
              celular: "",
              facebook: "",
              twitter: "",
              instagram: "",
              linkedin: "",
            },
            informacionAdicional: {
              notificarVencimiento: true,
              fechaNacimiento: "",
              contrato: "",
              detalleFicha: "",
              rutTitularConvenio: "",
            },
            accesoSucursal: {
              estadoAcceso: "",
            },
            avatar: {
              imagenMiniatura: "",
              imagenPerfil: "",
            },
          };
          this.showingCustomerOG = {};
        }
        this.show.customerCreator = false;
        this.show.customerDetails = false;
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  filter: {
                    nid: this.searchByCustomerNID
                      ? this.customerSearchParameter.toUpperCase()
                      : null,
                    name: this.searchByCustomerNID
                      ? null
                      : this.customerSearchParameter,
                  },
                  page: page ? page : 0,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/fetch/customers",
                },
              }
            )
            .then((res) => {
              // console.log(res);
              if (!res.data.error) {
                if (res.data.result.length > 0) {
                  this.customers = res.data.result;
                  if (this.pagination.total != res.data.count) {
                    this.pagination.total = res.data.count;
                  }
                } else {
                  this.$swal
                    .fire({
                      title: "Sin resultados!",
                      html: "<p>El socio que buscas al parecer no existe,<br/> verifica que el RUT sea el correcto </p>",
                      icon: "warning",
                      showConfirmButton: true,
                    })
                    .then(() => {
                      this.fetchCustomersPage(0);
                    });
                }
              } else {
                this.$swal.fire({
                  title: "Error! :(",
                  text: res.data.error,
                  icon: "error",
                  showConfirmButton: true,
                  confirmButtonColor: "#6bd098",
                });
              }
            });
        } catch (ex) {
          this.$swal.fire({
            title: "Error! :(",
            text: ex.message || ex,
            icon: "error",
            showConfirmButton: true,
            confirmButtonColor: "#6bd098",
          });
        }
      }
    },
    async fetchCustomersCatalogs() {
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {},
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/customers/catalogs",
              },
            }
          )
          .then((res) => {
            // console.log(res.data);
            if (!res.data.error) {
              this.catalog__socioEstados = [...res.data.status];
              this.catalog__socioEstadosAcceso = [...res.data.accessStatus];
              this.catalog__socioPerfiles = [...res.data.profiles];
            }
          });
      } catch (error) {
        console.error("''''''''error''''''''");
        console.error(error);
      } finally {
        return;
      }
    },
    handleCancelCustomerCreation() {
      this.newCustomer = {
        selectedOriginBranch: "",
        nombreSocio: "",
        esExtranjero: false,
        rut: "",
        sexo: "",
        perfilCuenta: "",
        estadoCuenta: "",
        autenticacion: {
          email: "",
          password: "123456",
        },
        informacionGeografica: {
          pais: "",
          ciudad: "",
          region: "",
          comuna: "",
          direccion: "",
        },
        informacionContacto: {
          emailSecundario: "",
          telefonoFijo: "",
          celular: "",
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: "",
        },
        informacionAdicional: {
          notificarVencimiento: true,
          fechaNacimiento: "",
          contrato: "",
          detalleFicha: "",
          rutTitularConvenio: "",
        },
        accesoSucursal: {
          estadoAcceso: "",
        },
        avatar: {
          imagenMiniatura: "",
          imagenPerfil: "",
        },
      };
      this.show.customerCreator = false;
    },
    createCustomer() {},
  },
  mounted() {
    // this.$swal.fire({
    //   title: "Cargando...",
    //   text: "Un momento por favor",
    //   allowOutsideClick: false,
    //   showConfirmButton: false,
    //   didOpen: () => {
    //     this.$swal.showLoading();
    //   },
    // });
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize();
    }
    this.branches = [...JSON.parse(sessionStorage.getItem("xxxwypt5ip"))];
    const nid = this.$store.getters.getCosturmerNIDcustomersAndMemberhipsFilter;

    // console.log("rut: ", nid);
    if (nid) {
      Promise.all([
        this.fetchCustomersPage(),
        this.fetchCustomersCatalogs(),
        this.fetchCustomerDetails(nid),
      ]).then((res) => {
        this.handleEnableCustomerEdit();
        this.$store.commit("setCosturmerNIDcustomersAndMemberhipsFilter", "");
        this.$swal.close();
      });
    } else {
      Promise.all([
        this.fetchCustomersPage(),
        this.fetchCustomersCatalogs(),
      ]).then((res) => this.$swal.close());
    }
  },
  beforeMount() {
    this.$swal.close();
  },
};
</script>

<style>
.round-button {
  height: 50px;
  width: 50px;
}
.mobile-table-text {
  max-width: 200px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
